import { render } from "./gameDev.vue?vue&type=template&id=65140b75&scoped=true"
import script from "./gameDev.vue?vue&type=script&lang=js"
export * from "./gameDev.vue?vue&type=script&lang=js"

import "./gameDev.vue?vue&type=style&index=0&id=65140b75&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65140b75"]])

export default __exports__